import { useEffect, useState } from 'react';
import { unitSystemCache } from './unitSystems';
import { ConversiontableListData } from '@/api/airchef/Api';

export const useConversionTable = () => {
  const [conversionTable, setConversionTable] = useState<ConversiontableListData | null>(null);

  useEffect(() => {
    const listener = (data: ConversiontableListData) => {
      if (data) setConversionTable(data);
    };
    // @ts-expect-error complex typings, skip
    unitSystemCache.addListener('conversion', listener);

    return () => {
      // @ts-expect-error complex typings, skip
      unitSystemCache.removeListener('conversion', listener);
    };
  }, []);

  return {
    conversionTable,
  };
};
